module.exports = __webpack_public_path__ + "static/img/27006.d996203.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/stockUniverse/27006.png
// module id = Y4p2
// module chunks = 0